"use client";

import { CmsErrorPage, type CmsErrorProps } from "@/core/CmsErrorPage";

export default function GlobalError(props: CmsErrorProps) {
  return <html lang="nl"><body style={{ margin: 0 }}><title>Pagina niet beschikbaar · Sculpto CMS</title><CmsErrorPage {...props} /></body></html>;
}
